import { EndUseStackedBarChart } from "components/organisms/Charts";
import { useAnnualCarbonEmissionsNaturalGasChart } from "queries/Reports/Baseline/useAnnualCarbonEmissionsNaturalGasChart";

function AnnualCarbonEmissionsNaturalGasChart({ filtersetUid }: { filtersetUid: string }) {
    const { data, isLoading, error } = useAnnualCarbonEmissionsNaturalGasChart(filtersetUid);

    return <EndUseStackedBarChart data={data} loading={isLoading} fuelTypeKey="naturalGas" error={error?.toString()} />;
}

export default AnnualCarbonEmissionsNaturalGasChart;
